module.exports = __webpack_public_path__ + "media/images/icons/group-green-6dd0db893701f47e6e32306774ece30f.svg";